import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
  selector: 'app-test-rating-range-selector',
  standalone: false,
  templateUrl: './test-rating-range-selector.component.html',
  styleUrl: './test-rating-range-selector.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TestRatingRangeSelectorComponent),
      multi: true,
    },
  ],
})
export class TestRatingRangeSelectorComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private _selection: number[] = [null, null]
  private onChange: (value: number[]) => void = () => {}
  private onTouched: () => void = () => {}
  private disabled: boolean = false

  public get minRating(): number {
    return this._selection[0]
  }

  public get maxRating(): number {
    return this._selection[1]
  }

  public get selection(): number[] {
    return this._selection
  }

  public writeValue(obj: number[] | null): void {
    if (obj && Array.isArray(obj) && obj.length === 2) {
      this._selection = [...obj]
    } else {
      this._selection = [null, null]
    }
  }

  public registerOnChange(fn: (value: number[]) => void): void {
    this.onChange = fn
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  public onMinRatingChange(rating: number): void {
    if (this.disabled) {
      return
    }

    this._selection[0] = rating

    this.emitChange()
    // if (this._selection[1] !== null && rating > this._selection[1]) {
    //   this._selection[0] = this._selection[1]
    // } else {
    //   this._selection[0] = rating
    // }
  }

  public onMaxRatingChange(rating: number): void {
    if (this.disabled) {
      return
    }

    this._selection[1] = rating

    this.emitChange()
    // if (this._selection[0] !== null && rating < this._selection[0]) {
    //   this._selection[1] = this._selection[0]
    // } else {
    //   this._selection[1] = rating
    // }
  }

  private emitChange(): void {
    if (this._selection && this._selection.length === 2 && this._selection.indexOf(null) === -1) {
      this.onChange([...this._selection])
      this.onTouched()
    }
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}
}
